<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="dedicenter"><a id="pV">To Dominic, Sam, Rhys, Calum and Cieran</a></p><a id="pV">
</a></div><a id="pV">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005Dedication.vue?34d189d4